import { render, staticRenderFns } from "./sendMonthlyStatistics.vue?vue&type=template&id=20044baa&scoped=true"
import script from "./sendMonthlyStatistics.vue?vue&type=script&lang=js"
export * from "./sendMonthlyStatistics.vue?vue&type=script&lang=js"
import style0 from "./sendMonthlyStatistics.vue?vue&type=style&index=0&id=20044baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20044baa",
  null
  
)

export default component.exports